import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';

import AccountSelectorListView from 'components/accountSelector/AccountSelectorListView';
import styles from './styles/AccountSelectorStyles';
import * as miscServices from 'services/miscServices';

import {fetchSubAccounts} from 'actions/userActions';

class AccountSelector extends React.Component {
    constructor(props){
        super(props);

        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleSelectAccountId = this.handleSelectAccountId.bind(this);
        this.handleClearAccount = this.handleClearAccount.bind(this);
        this.handleLoadSubAccountsAccount = this.handleLoadSubAccountsAccount.bind(this);

        var selectedIndex = null;
        var selectedItem = null;

        if(props.selectedAccount)
        {
            selectedIndex = props.selectedAccount.id;
            selectedItem = props.selectedAccount;
        }

        this.state = {
            modalOpen: false,
            isSearching: false,
            selectedItem: selectedItem,
            selectedIndex: selectedIndex
        };
    }

    componentWillReceiveProps(newProps){

        if(newProps.selectedAccount === this.props.selectedAccount)
        {
            console.log("componentWillReceiveProps account not modified");
            return;
        }

        var selectedIndex = null;
        var selectedItem = null;

        if(newProps.selectedAccount)
        {
            selectedIndex = newProps.selectedAccount.id;
            selectedItem = newProps.selectedAccount;
        }

        this.setState({
            selectedItem: selectedItem,
            selectedIndex: selectedIndex
        });
    }


    /**
     * modal popup - search form
     */
    handleOpen = () => {
        this.setState({modalOpen: true});
    };

    /**
     * modal popup - search form
     */
    handleClose = () => {
        this.setState({modalOpen: false});
    };

    handleSelectAccountId(id){
        var selectedAccount = miscServices.getItemFromListById(this.props.accountList, id);
        if (!selectedAccount)
        {
            throw new Error("Account not found");
        }

        this.setState({
            selectedItem: selectedAccount,
            selectedIndex: id
        }, this.props.handleSelectedAccount(selectedAccount))
    }

    handleLoadSubAccountsAccount(id){
        this.props.fetchSubAccounts(id);
    }

    handleClearAccount(){
        this.setState({
            selectedItem: null,
            selectedIndex: null
        }, this.props.handleSelectedAccount(null))
        this.handleClose();
    }

    render() {
        const {translate, accountList } = this.props;
        const {isSearching, selectedItem, modalOpen } = this.state;

        const actions = [
            <RaisedButton label={translate('GLOBAL.clear')}
                            style={styles.selectButton}
                            onClick={this.handleClearAccount}
                            disabled={isSearching}
                            icon={isSearching ? <CircularProgress size={25} />: <div></div>}
                            secondary={true}>
            </RaisedButton>,
            <RaisedButton label={translate('GLOBAL.select')}
                            style={styles.selectButton}
                            onClick={this.handleClose}
                            disabled={isSearching}
                            icon={isSearching ? <CircularProgress size={25} />: <div></div>}
                            primary={true}>
            </RaisedButton>
          ];

        var accountModalTitle = translate('AccountListSelection.title');
        var selectedAccountTitle = "";

        if(selectedItem)
        {
            accountModalTitle = translate('SearchBox.selectedAccount') + ": " + selectedItem.title;
            selectedAccountTitle = selectedItem.title;
        }

        console.log("AccountSelector rendered");

        return (
            <div>
                <TextField
                    type="text"
                    value={selectedAccountTitle}
                    hintText={translate('GLOBAL.account')}
                    floatingLabelText={translate('GLOBAL.account')}
                    onClick={this.handleOpen}
                    fullWidth={true} />

                <Dialog
                    title={accountModalTitle}
                    modal={false}
                    contentStyle={styles.searchFormModalWidth}
                    open={modalOpen}
                    autoScrollBodyContent={true}
                    actions={actions}
                    onRequestClose={this.handleClose}
                >
                    <AccountSelectorListView
                        accountList={accountList}
                        selectedIndex={this.state.selectedIndex}
                        handleLoadSubAccountsAccount={this.handleLoadSubAccountsAccount}
                        handleSelectAccountId={this.handleSelectAccountId}  />
                </Dialog>
            </div>
        );
    }
}

AccountSelector.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        accountList: state.user.accountList
    }
}
export default connect(mapStateToProps, {fetchSubAccounts})(AccountSelector);


// WEBPACK FOOTER //
// ./src/containers/accountSelector/AccountSelector.js